import { FunctionComponent } from 'react'
import classnames from 'classnames'

import brandLogoCss from './brandLogo.module.scss'

/** Clic-repasse mark (bar chart) followed by the product name. */
const BrandLogo: FunctionComponent<{ className?: string }> = ({ className }) => (
  <span className={classnames(brandLogoCss.brand, className)}>
    <svg
      className={brandLogoCss.mark}
      viewBox="4 4 16 16"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M8 20H4V9h4zm6 0h-4V4h4zm6 0h-4v-7h4z" />
    </svg>
    <span>Clic-repasse</span>
  </span>
)

export default BrandLogo
